import InventoryStore, { UpdateInventoryItemParams } from 'admin/InventoryStore'
import { task } from 'mobx-task'
import { BaseInventoryItemViewModel } from '../BaseInventoryItemDialog/BaseInventoryItemViewModel'
import { AlertFactory, AlertState } from 'alerts/Alert'
import Workspace from 'iam/models/Workspace'
import { RefreshInventoryItems } from 'admin/inventory/InventorySearchViewModel'
import { SupportingItemsPorts } from '../../../ports'
import { InventoryItemProVisibility } from '@taxfyle/api-internal/internal/inventory_item_pb'

export default class EditInventoryItemViewModel extends BaseInventoryItemViewModel {
  constructor(
    private inventoryStore: InventoryStore,
    private newAlert: AlertFactory,
    private refreshItems: RefreshInventoryItems,
    public getSelectedWorkspace: () => Workspace | undefined,
    supportingItemsAdapter: SupportingItemsPorts,
  ) {
    super(supportingItemsAdapter)
  }

  /** * Creates the inventory item
   */
  submit = task.resolved(async () => {
    if (!this.validation.reset().validate().isValid) {
      return
    }

    const typeSpec = this.getInventoryItemTypeSpecification()

    const pricing = this.pricingViewModel.toValues()

    const updatedItem: UpdateInventoryItemParams = {
      name: this.name,
      description: this.description,
      courtesyAmount: this.courtesyQuantity,
      pricing,
      supportingItems: this.supportingItems,
      documentSignatureItems: this.documentSignatureItems,
      proVisibility: this.hideFromPro
        ? InventoryItemProVisibility.HIDDEN
        : InventoryItemProVisibility.VISIBLE,
      typeSpecification: typeSpec,
    }

    await this.inventoryStore
      .update(this.item!.id, updatedItem)
      .then(async () => {
        this.newAlert()
          .withState(AlertState.Success)
          .saying('Success', 'Item edited.')
          .autoDismiss()
          .show()

        const workspace = this.getSelectedWorkspace()

        // Refresh the list to show new items
        await this.refreshItems(workspace || Workspace.none)

        this.close()
      })
      .catch((e) => {
        this.newAlert()
          .withState(AlertState.Error)
          .saying('Error', e.message)
          .autoDismiss(2000)
          .show()
      })
  })
}
